import { __assign as i } from "../../tslib/tslib.es6.js";
import { noCase as t } from "../../no-case/dist.es2015/index.js";
function e(e, o) {
  return void 0 === o && (o = {}), t(e, i({
    delimiter: "."
  }, o));
}
export { e as dotCase };